import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "outRole",
  "use": "outRole-usage",
  "viewBox": "0 0 11.07 8.15",
  "content": "<symbol viewBox=\"0 0 11.07 8.15\" id=\"outRole\"><title>22</title><path d=\"M13.82,7.77,8.57,5.51a.25.25,0,0,0-.2,0L3.12,7.77a.34.34,0,0,0,0,.61l5.25,2.26a.25.25,0,0,0,.2,0l4.08-1.75v1.8a.77.77,0,0,0,0,1.32v.63h.54V12a.77.77,0,0,0,0-1.32v-2l.63-.27a.34.34,0,0,0,0-.61ZM8.47,11.08A.58.58,0,0,1,8.23,11L5,9.63v1.94c0,1.59,2.39,2.07,3.13,2.07h.75c.56,0,3.13-.48,3.13-2.07V9.63L8.7,11A.57.57,0,0,1,8.47,11.08Z\" transform=\"translate(-2.93 -5.49)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/outRole.svg
// module id = jxzN
// module chunks = 264